// extracted by mini-css-extract-plugin
module.exports = {"arrows":"Pagination_arrows__zdgTj","arrowsAr":"Pagination_arrowsAr__2sME7","arrowsEn":"Pagination_arrowsEn__1JkMu"};